import { render, staticRenderFns } from "./customs-validation.vue?vue&type=template&id=51c2be21&scoped=true"
import script from "./customs-validation.vue?vue&type=script&lang=js"
export * from "./customs-validation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c2be21",
  null
  
)

export default component.exports